export default __webpack_public_path__ + "static/media/mylogo.d119b629.png";